import { Amplify, Auth } from 'aws-amplify'
import awsconfig from '../../aws-exports'

Amplify.configure(awsconfig)

// This function initiates the resetting of a password by sending an email to the
// user's email. This is only the initiation of the reset.
export async function ForgotPassword(userData) {
  const { email } = userData
  return Auth.forgotPassword(email)
}

/* This function finalizes the reset of a user's
   password by sending the email address, the confirmation code,
   and the new password to Cognito via the forgotPasswordSubmit API.
*/
export function forgotPasswordConfirm(userData) {
  const { emailAddress, confirmationCode, newPassword } = userData
  return Auth.forgotPasswordSubmit(emailAddress, confirmationCode, newPassword)
}
